import React, { useMemo, useState, useEffect, useContext } from "react";
import { SUBSCRIPTION_GRACE_REPORT, } from "../../services/apiRoutes";
import { AuthContext } from "../../context/AuthContext";
import CustomLoader from "../../components/common/CustomLoader";
import CustomReport from "../../components/common/CustomReport";
import { useCompanyDateFormat } from "../../constants/useCompanyDateFormat";
import { getCustumersList } from "../../services/CommonServices";
import { genericPost } from "../../services/authServices";
import CustomButton from "../../components/common/CustomButton";
import CustomTextField from "../../components/common/CustomTextField";
import CustomFilter from "../../components/common/CustomFilter";
import { Box, Grid } from "@mui/material";
import FindReplaceOutlinedIcon from '@mui/icons-material/FindReplaceOutlined';
import { ClearRounded, } from "@mui/icons-material";
import CustomDataTable from "../../components/common/CustomDataTable";
import { AccessDenied, hasCreatePermission, hasDeletePermission, hasEditPermission, hasViewPermission } from "../../services/CommonServices";
import { useLocation } from "react-router-dom";

const title = "Subscription Grace Report";

const SubscriptionGraceReport = () => {
    const companyDateFormat = useCompanyDateFormat();
    const [data, setData] = useState([]);
    const { token } = useContext(AuthContext)
    const [permission, setPermissions] = useState()
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const filterOpen = () => setOpenDrawer(true);
    const filterClose = () => setOpenDrawer(false);
    const [openDrawer, setOpenDrawer] = useState(false);
    const [custumersList, setCustumersList] = useState([]);
    const [page, setPage] = useState(0); // UI 0-based
    const [pageSize, setPageSize] = useState(10);
    const [rowCount, setRowCount] = useState(0);

    const [filterPayload, setFilterPayload] = useState({

    });
    const location = useLocation();
    const currentPath = location.pathname;
    useEffect(() => {
        let rolePermisionsData = JSON.parse(sessionStorage.getItem('userData')) || []
        let editPermision = hasEditPermission(currentPath, rolePermisionsData?.permissions)
        let deletePermission = hasDeletePermission(currentPath, rolePermisionsData?.permissions)
        let createPermision = hasCreatePermission(currentPath, rolePermisionsData?.permissions)
        let viewPermision = hasViewPermission(currentPath, rolePermisionsData?.permissions)

        setPermissions({
            edit: editPermision,
            delete: deletePermission,
            create: createPermision,
            view: viewPermision,
        })
    }, [])
    const handleFilterChange = (field, value) => {
        setFilterPayload((prev) => ({
            ...prev,
            [field]: value || '',
        }));
    };
    const handleClearFilters = useMemo(() => {
        return () => {
            setFilterPayload({
            });
            fetchData(0, pageSize, '');
        };
    }, [pageSize]);
    useEffect(() => {
        getCommonData();
    }, []);
    const getCommonData = async () => {
        const custumersList = await getCustumersList();
        setCustumersList(custumersList);
    }

    const columns = useMemo(
        () => [
            { accessorKey: "index", header: "SN.", size: 50, tableHeader: { alignItems: 'center', }, tableStyle: { textAlign: "center" }, enableColumnFilter: false },
            {
                accessorKey: "userName", header: "User Name", size: 100, enableSorting: true, tableHeader: {
                    justifyContent: 'flex-start',
                },
            },
            { accessorKey: "mobile", header: "Contact No.", size: 100, enableSorting: true, tableStyle: { textAlign: "center" }, },
            {
                accessorKey: "email", header: "Email ID", size: 100, enableSorting: true, tableHeader: {
                    justifyContent: 'flex-start',
                },
            },
            {
                accessorKey: "clientCompanyName", header: "Company", size: 100, enableSorting: true, tableHeader: {
                    justifyContent: 'flex-start',
                },
            },
            {
                accessorKey: "totalUsers",
                header: "Total Users",
                size: 50,
                tableStyle: { textAlign: "center" },
                enableSorting: true
            },
            {
                accessorKey: "totalCompanies",
                header: "Total Company",
                size: 50,
                tableStyle: { textAlign: "center" },
                enableSorting: true
            },
            {
                accessorKey: "startDate",
                header: "Start Date",
                size: 50,
                tableStyle: { textAlign: "center" },
                enableSorting: true
            },
            {
                accessorKey: "endDate",
                header: "End Date",
                size: 50,
                tableStyle: { textAlign: "center" },
                enableSorting: true
            },

        ],
        [permission,]
    );

    const fetchData = async (pageIndex = 0, pageSize = 10) => {
        setLoading(true);
        try {
            const payload = {
                page: pageIndex + 1,
                limit: pageSize,
            };
            const response = await genericPost(SUBSCRIPTION_GRACE_REPORT, payload, {});
            if (response.data.success && response.data.data?.length > 0) {
                const subscriptionData = response.data.data.map((item, index) => ({
                    index: (index + 1).toString().padStart(2, '0'),
                    id: item.id || '',
                    clientCompanyName: item.organization.company?.companyName || '',
                    mobile: item?.organization.user?.mobile || '',
                    email: item?.organization.user?.email || '',
                    userName: `${item.organization.user?.firstName || ''} ${item?.organization.user?.lastName || ''}`.trim(),
                    companyAdmin: '',
                    totalUsers: item.organization.totalUsers || 0,
                    totalCompanies: item.organization.totalCompany || 0,
                    endDate: item.organization.endDate || '',
                    startDate: item.organization.subscriptionStartedOn || '',
                }));

                setData(subscriptionData);
                setRowCount(response.data.pagination?.totalRecords || 0);

            } else {
                setError('No subscription records found');
            }
        } catch (error) {
            console.error('Error fetching subscriptions:', error);
            setError('Error fetching subscription data');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(page, pageSize)
    }, [token, page, pageSize])


    const defaultView = 'deleteduserrecords';
    const mainContent = (
        <>
            <CustomLoader open={loading} />
            <CustomDataTable
                title={title}
                columns={columns}
                data={data}
                openDrawer={openDrawer}
                onClose={filterClose}
                handleFilterButton={filterOpen}
                // fiterButtonTitile="Fiter"
                rowCount={rowCount}
                page={page}
                setPage={setPage}
                pageSize={pageSize}
                setPageSize={setPageSize}

            />
            <CustomFilter
                drawerTitle="Filter Options"
                drawerWidth={300}
                openDrawer={openDrawer}
                onClose={filterClose}
                drawerContent={
                    <>
                        <Box>
                            <Grid container spacing={1} sx={{ padding: 0, }}>
                                <Grid item xs={12}>
                                    <CustomTextField
                                        placeholder="Search Company"
                                        type="text"
                                        value={filterPayload.companyName}
                                        onChange={(e) => handleFilterChange('companyName', e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <CustomTextField
                                        placeholder="Mobile"
                                        type="text"
                                        value={filterPayload.mobile}
                                        onChange={(e) => handleFilterChange('mobile', e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <CustomTextField
                                        placeholder="Email"
                                        type="text"
                                        value={filterPayload.email}
                                        onChange={(e) => handleFilterChange('email', e.target.value)}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={12}>
                                    <CustomTextField
                                        fieldLabel="from Date"
                                        type="date"
                                        value={filterPayload.fromDate}
                                        onChange={(e) => handleFilterChange('fromDate', e.target.value)}
                                        placeholder="From Date"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12}>
                                    <CustomTextField
                                        fieldLabel="to Date"
                                        type="date"
                                        value={filterPayload.toDate}
                                        onChange={(e) => handleFilterChange('toDate', e.target.value)}
                                        placeholder="To Date"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} sx={{ display: 'flex', alignItems: 'center', marginTop: "10px" }}>

                                    <CustomButton
                                        startIcon={<FindReplaceOutlinedIcon />}
                                        title="Apply"
                                        size="small"
                                        variant="contained"
                                        onClick={fetchData}
                                    />
                                    <CustomButton
                                        variant="outlined"
                                        title="Clear"
                                        startIcon={<ClearRounded />}
                                        style={cif_fob_style}
                                        onClick={handleClearFilters}
                                    />

                                </Grid>
                            </Grid>
                        </Box>
                    </>
                }
            />
        </>
    );
    const getMainContent = (mainContent, permission) => {
        return permission?.view ? mainContent : null;
    };
    return (
        <>
            <CustomReport
                defaultView={defaultView}
                mainContent={getMainContent(mainContent, permission)}
            />
            {!permission?.view && <AccessDenied />}

        </>
    );
};
export default SubscriptionGraceReport;

const cif_fob_style = {
    backgroundColor: '#ffff',
    color: '#007bff',
    textTransform: "capitalize",
    borderRadius: 4,
    border: '1px solid #007bff',
    height: 30,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: "100px"

}
